/**
 * For CPS Deposit Listing Ordering
 * (CPS Module)
 */

/** plese refer to this conference
 * https://suntontech.atlassian.net/wiki/spaces/DEV/pages/1552451151/CPS+Deposit+Channels+Updated+on+22+May+2023
 * and double check from cps
 */

import { countryCodeEnum } from '@/constants/country'

export const cpsDepositListingIndex = [
  {
    id: 'global',
    order: [
      'T00800', //credit card
      'T00600_500', //International Bank Transfer
      'GIBTT00600', //International Bank Transfer
      'T00600_060', // Malaysia FPX
      'T00100_046', // Malaysia Ewallet
      'GMYT00600', // Malaysia Instant Bank Transfer
      'T00600_058', // South Africa Instant Bank Transfer
      'GIDT00600', // Indonesia Instant Bank Transfer
      'T00600_076', // Indonesia Virtual Account Bank Transfer
      'T00600_055', // India Instant Bank Transfer
      'T00312_026', // India UPI
      'GCOT00600', // Colombia Instant Bank Transfer
      'GMXT00600', // Mexico Instant Bank Transfer
      'T00600_052', // Nigeria Instant Bank Transfer
      'GBRT00600', // Brazil Instant Bank Transfer
      'T00600_053', // Japan Instant Bank Transfer (update: please refer to confluence above)
      'T00100_047', // Bitwallet
      'GCLT00600', // Chile Instant Bank Transfer
      'T00600_066', // Peru Instant Bank Transfer
      'GPHT00600', // Philippines Instant Bank Transfer
      'GVNT00600', // Vietnam instant bank wire transfer
      'T00600_056', // Dollar Smart
      'T00100_059', // EBuy
      'GT00400', // Crypto
      'T00100_051', // FasaPay
      'T00100_052', // Perfect Money
      'T00100_058', // Neteller
      'T00100_057', // Skrill
      'T00312', // Alipay
      'GCNT00600', // China Union Pay
    ],
  },
  {
    id: countryCodeEnum.THAILAND,
    order: [
      'GTHT00600', // Thailand Instant Bank Transfer
      'GT00400', // Crypto
      'GMYT00600',
      'T00100_051', // FasaPay
      'T00100_052', // Perfect Money
      'T00100_058', // Neteller
      'T00100_057', // Skrill
      'T00312', // Alipay
    ],
  },
  {
    id: countryCodeEnum.CHINA,
    order: [
      'GCNT00600',
      'GT00400',
      'T00312',
      'T00100_051', // FasaPay
      'T00100_052', // Perfect Money
      'T00100_058', // Neteller
      'T00100_057', // Skrill
      'GGLOBALT00600_059', //WISE
      'T00600_500', //International Bank Transfer
      'GIBTT00600', //International Bank Transfer
    ],
  },
  {
    id: countryCodeEnum.MACAO,
    order: [
      'GCNT00600',
      'GT00400',
      'T00312',
      'T00312_023',
      'T00600_067',
      'T00100_051', // FasaPay
      'T00100_052', // Perfect Money
      'T00100_058', // Neteller
      'T00100_057', // Skrill
    ],
  },
  {
    id: countryCodeEnum.HONG_KONG,
    order: [
      'T00600_500', //International Bank Transfer
      'GIBTT00600', //International Bank Transfer
      'GCNT00600',
      'GT00400',
      'T00312',
      'T00312_023',
      'T00600_067',
      'T00100_051', // FasaPay
      'T00100_052', // Perfect Money
      'T00100_058', // Neteller
      'T00100_057', // Skrill
    ],
  },
  {
    id: countryCodeEnum.INDIA,
    order: [
      'GIN2T00600',
      'T00600_500', //International Bank Transfer
      'GIBTT00600', //International Bank Transfer
    ],
  },
  {
    id: countryCodeEnum.BRAZIL,
    order: [
      'T00600_500', //International Bank Transfer
      'GIBTT00600', //International Bank Transfer
      'GBRT00600',
      'T00312_033',
    ],
  },
]
